import { PDFDocument } from "pdf-lib";
import type { PdfBuilder as IPdfBuilder } from "../state/captureSession";

export class PdfBuilder implements IPdfBuilder {
  async build(pages: Blob[]): Promise<Blob> {
    if (pages.length === 0) {
      throw new Error("PdfBuilder.build called with empty pages");
    }

    const doc = await PDFDocument.create();

    for (const page of pages) {
      const bytes = new Uint8Array(await page.arrayBuffer());
      const image =
        page.type === "image/png"
          ? await doc.embedPng(bytes)
          : await doc.embedJpg(bytes);
      const pdfPage = doc.addPage([image.width, image.height]);
      pdfPage.drawImage(image, { x: 0, y: 0, width: image.width, height: image.height });
    }

    const out = await doc.save();
    const buffer = new ArrayBuffer(out.byteLength);
    new Uint8Array(buffer).set(out);
    return new Blob([buffer], { type: "application/pdf" });
  }
}
